// Сбрасывает дефолтные XHR-заголовки, установленные в конструкторе Axios
export var transformRequest = [function (data, headers) {
  headers.common = {};
  return data;
}];